module.exports = __webpack_public_path__ + "static/66-9c24150a08b686cb82bfeee8f46a723c.png";